// extracted by mini-css-extract-plugin
export var box = "Intro-module--box--57014";
export var box_md = "Intro-module--box_md--e3b8e";
export var box_xmd = "Intro-module--box_xmd--6e00c";
export var box_flex = "Intro-module--box_flex--8868e";
export var box_lg = "Intro-module--box_lg--6d8a4";
export var box_sm = "Intro-module--box_sm--2c72f";
export var box_outer = "Intro-module--box_outer--93dfd";
export var box_whiteBg = "Intro-module--box_white-bg--59eb5";
export var box_noMarginBottom = "Intro-module--box_no-margin-bottom--40116";
export var box_noPadding = "Intro-module--box_no-padding--a878e";
export var box_outerGray = "Intro-module--box_outer-gray--d9282";
export var box_dark = "Intro-module--box_dark--1a442";
export var box_zIndex = "Intro-module--box_z-index--999b0";
export var box_zIndex6 = "Intro-module--box_z-index-6--1fe20";
export var box_eventsWithLine = "Intro-module--box_events-with-line--7394b";
export var box_featuresAo = "Intro-module--box_features-ao--83047";
export var box_verticalPaddings = "Intro-module--box_vertical-paddings--778ee";
export var clearP = "Intro-module--clearP--8ee4a";
export var clearP_vc = "Intro-module--clearP_vc--a6d29";
export var innerContainer = "Intro-module--innerContainer--0804e";
export var layout = "Intro-module--layout--ee42f";
export var title = "Intro-module--title--5e844";
export var subtitle = "Intro-module--subtitle--05888";
export var picture = "Intro-module--picture--b7382";
export var img = "Intro-module--img--c8e46";
export var fadeInAnimation = "Intro-module--fadeInAnimation--a5b83";
export var placeHolderShimmer = "Intro-module--placeHolderShimmer--6bfcc";